import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import Swal from 'sweetalert2';

import { CarretaService } from '../CarretaService/carreta.service';
import { CavaloService } from '../CavaloService/cavalo.service';
import { MotoristaService } from '../MotoristaService/motorista.service';
import { IUploadAPI, IUploadBody } from './upload.model';
import { SwalAlertService } from '../SwalAlertService/swalAlert.service';
@Injectable({
  providedIn: 'root'
})
export class UploadService {
  guid = generateUUID();
  constructor(
    private cavaloService: CavaloService,
    private carretaService: CarretaService,
    private motoristaService: MotoristaService,
    private swalAlert: SwalAlertService
  ) {}

  API: IUploadAPI = {
    cavalo: (body: any, guid: string) =>
      this.cavaloService.CreateCavaloUpload(body, guid),
    carreta: (body: any, guid: string) =>
      this.carretaService.CreateCarretaUpload(body, guid),
    motorista: (body: any, guid: string) =>
      this.motoristaService.CreateMotoristaUpload(body, guid)
  };

  createByUpload(
    body: IUploadBody,
    guid: string,
    fieldName: keyof IUploadAPI
  ): Subscription {
    return this.API[fieldName](body, guid).subscribe({
      next: () => {
        this.swalAlert.showAlert(
          'Sucesso!',
          'Upload realizado com sucesso.',
          'success',
          true,
          false,
          undefined
        );
      },
      error: (error: any) => {
        this.swalAlert.handleError(
          error,
          'Atenção!',
          'Ocorreu um erro no upload. Por favor, verifique a planilha e tente novamente',
          'warning'
        );
      }
    });
  }

  downloadTemplateUpload(fieldName: keyof IUploadAPI) {
    const url = `assets/template/${fieldName}.xlsx`;
    const link = document.createElement(`a`);
    link.href = url;
    link.download = `${fieldName}.xlsx`;
    link.click();
  }
}
